/**
 * FmRiskWorkspace severity/banner token maps
 * Runtime constants kept out of the component modules so the region + shell
 * files export components only (react-refresh). Severity colour itself is
 * resolved in CSS from muem9.18 tokens via `data-severity`; these maps only
 * translate semantic severity/banner tone into the DS primitives' own semantic
 * tone vocabulary — no raw colour here.
 */
import type { FmBannerTone } from './FmBanner';
import type { FmRiskBanner, FmRiskRowTone, FmRiskSeverity } from './FmRiskWorkspace.types';

/** Ranked-row tone the DS list primitive understands. */
export const SEVERITY_ROW_TONE: Record<FmRiskSeverity, FmRiskRowTone> = {
  none: 'default',
  advisory: 'default',
  warning: 'warning',
  critical: 'critical',
};

/** Banner tone → FmBanner tone (critical maps to the error treatment). */
export const BANNER_TONE: Record<FmRiskBanner['tone'], FmBannerTone> = {
  info: 'info',
  warning: 'warning',
  critical: 'error',
};
